import {Component, computed, inject, OnInit, signal} from '@angular/core';
import {CommonModule} from '@angular/common';
import {Router} from '@angular/router';
import {NgbNavModule} from '@ng-bootstrap/ng-bootstrap';
import {RoleAssignApiService} from '../role-assign/role-assign-api.service';
import {RoleAssignmentDto} from '../../../models/generated-models';
import {RoleInvitationService} from './role-invitation.service';
import {PageTitleComponent} from '../../shared/commons/page-title/page-title.component';
import {ThaiDateTimePipe} from '../../shared/commons/thai-datetime.pipe';

@Component({
  selector: 'app-role-invitation-list',
  standalone: true,
  imports: [CommonModule, PageTitleComponent, NgbNavModule, ThaiDateTimePipe],
  templateUrl: './role-invitation-list.component.html',
  styleUrl: './role-invitation-list.component.scss'
})
export class RoleInvitationListComponent implements OnInit {
  private readonly api = inject(RoleAssignApiService);
  private readonly invitationService = inject(RoleInvitationService);
  private readonly router = inject(Router);

  activeTab = signal<'ALL' | 'PENDING' | 'ACCEPTED' | 'REJECTED'>('ALL');
  protected readonly loading = signal(false);
  protected readonly items = signal<RoleAssignmentDto[]>([]);

  protected readonly pendingCount = computed(() =>
    this.items().filter(i => (i.invitationStatus || 'PENDING').toUpperCase() === 'PENDING').length
  );

  protected readonly acceptedCount = computed(() =>
    this.items().filter(i => (i.invitationStatus || '').toUpperCase() === 'ACCEPTED').length
  );

  protected readonly rejectedCount = computed(() =>
    this.items().filter(i => (i.invitationStatus || '').toUpperCase() === 'REJECTED').length
  );

  protected readonly filteredItems = computed(() => {
    const list = this.items();
    const tab = this.activeTab();
    if (tab === 'ALL') {
      return list;
    }
    return list.filter(i => (i.invitationStatus || 'PENDING').toUpperCase() === tab);
  });

  ngOnInit(): void {
    this.loadData();
  }

  loadData(): void {
    this.loading.set(true);
    this.api.listReceived().subscribe({
      next: (data) => {
        this.items.set(data || []);
        this.loading.set(false);
        this.invitationService.refreshPendingCount().subscribe({
          error: () => {
          }
        });
      },
      error: () => {
        this.loading.set(false);
      }
    });
  }

  onTabChange(tab: 'ALL' | 'PENDING' | 'ACCEPTED' | 'REJECTED'): void {
    this.activeTab.set(tab);
  }

  openDetail(item: RoleAssignmentDto): void {
    if (item.id != null) {
      void this.router.navigate(['/profile/role-invitations', item.id]);
    }
  }

  getStatusLabel(status?: string): string {
    switch (status?.toUpperCase()) {
      case 'ACCEPTED':
        return 'ตอบรับแล้ว';
      case 'REJECTED':
        return 'ปฏิเสธแล้ว';
      case 'PENDING':
      default:
        return 'รอการตอบรับ';
    }
  }

  getStatusClass(status?: string): string {
    switch (status?.toUpperCase()) {
      case 'ACCEPTED':
        return 'status-approved';
      case 'REJECTED':
        return 'status-rejected';
      case 'PENDING':
      default:
        return 'status-pending';
    }
  }
}
